<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="col-6">
        <div class="p-card-field">
          <label class="indam-car-for-sell p-col-fixed txt-right txt-required">Vehicle Category</label>
          <div class="p-col">
            <v-select :clearable="false" placeholder="Choose" v-model="obj_data.vehicle_category_id"
              :options="ListvehicleCategory" :reduce="item => item.id" label="name">
              <span slot="no-options" @click="$refs.select.open = false">Empty data</span>
            </v-select>
            <input class="input_tmp_validator" id="vehicle_category_id">
          </div>
        </div>
      </div>
      <!-- thêm input alt -->
      <div class="col-6">
        <div class="p-card-field">
          <label class="indam-car-for-sell p-col-fixed txt-right ">Alt</label>
          <div class="p-col">
            <InputText id="name" class="p-inputtext p-col-width pac-target-input ml-0"
              placeholder="Input (max 255 charactors)" v-model="obj_data.alt" maxlength="255" />
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="p-card-field">
          <label class="indam-car-for-sell p-col-fixed txt-right txt-required">Description</label>
          <div class="p-col">
            <input class="input_tmp_validator" id="validator_content_description">
            <CkditorCore :contentSet="obj_data.description" @newdata="handleDataCkditor($event, 0, 'description')">
            </CkditorCore>
          </div>
        </div>
      </div>

      <div class="col-3">
        <!-- Cover -->
        <div class="p-card-field">
          <label class="indam-car-for-sell p-col-fixed txt-right txt-required">Cover image </label>
          <div class="p-col">
            <div class="cus-text opacity-text-file">Recommended: 800x450px</div>
            <div class="cus-text opacity-text-file">Accepted: JPG, JPEG, PNG, GIF.</div>
            <input class="p-inputtext p-component" accept="image/*" name="images[]" id="images_service" type="file"
              @change="onFileSelectFileCover" />
            <input class="input_tmp_validator" id="list_file_cover">
            <div class="cus-text style_list_image">
              <div class="box-image" v-for="(item, index) in list_file_cover" :key="index">
                <img class="style_img" :src="item.objectURL" />
                <div class="button-clear" @click="onFileClearCover(item, index)"><img
                    src="/assets/images/icon/cancel_black_24dp.png" /></div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-card-field">
          <label class="indam-car-for-sell p-col-fixed txt-right txt-required">Car image</label>
          <div class="p-col">
            <div class="cus-text opacity-text-file">Recommended: 800x450px</div>
            <div class="cus-text opacity-text-file">Accepted: JPG, JPEG, PNG, GIF.</div>
            <input class="p-inputtext p-component" accept="image/*" name="images[]" id="images_service" type="file"
              @change="onFileSelectFile" multiple />
            <input class="input_tmp_validator" id="list_file">
            <div class="cus-text style_list_image">
              <div class="box-image" v-for="(item, index) in list_file" :key="index">
                <img class="style_img" :src="item.objectURL" />
                <div class="button-clear" @click="onFileClear(item, index)"><img
                    src="/assets/images/icon/cancel_black_24dp.png" /></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6">
        <!-- New -->
        <div class="p-card-field div_check">
          <div class="p-col checkbox">
            <Checkbox v-model="obj_data.new" :binary="true" />
            <label class="p-col-fixed txt-right text">New</label>
          </div>
        </div>
      </div>
      <div class="col-6">
        <!-- Active -->
        <div class="p-card-field div_check">
          <div class="p-col checkbox">
            <Checkbox v-model="obj_data.active" :binary="true" />
            <label class="p-col-fixed txt-right text">Active</label>
          </div>
        </div>
      </div>

      <!-- Buttons -->
      <Toolbar class="fixed-bottom-toolbar div-button">
        <template slot="right">
          <Button :label="$constants.TEXT_BUTTON.BACK" @click="backToList()" class="p-button-outlined" id="back" />
          <Button v-if="mode == 'edit'" id="edit" :label="$constants.TEXT_BUTTON.EDIT" @click="saveData()"
            class="main-style-button" />
          <Button v-else :label="$constants.TEXT_BUTTON.ADD" @click="saveData()" class="main-style-button" />
        </template>
      </Toolbar>
    </div>
    <CustomCropper
      :key="keyCropper"
      v-if="showCropper"
      :image-src="imageSrc"
      @cropped-image="handleCroppedImage"
      @close="showCropper = false"
    />
  </form>
</template>

<script>
import CkditorCore from '../CkditorCore';

export default {
  components: {
    CkditorCore
  },
  props: {
    mode: String,
    model: Object,
  },
  data() {
    return {
      showCropper: false,
      keyCropper: 0,
      imageSrc: null,
      showDeleteDialog: false,
      ListvehicleCategory: [],
      obj_data: {
        new: false,
        active: true,
        description: '', // Đảm bảo rằng description được khởi tạo
      },
      list_id_file_delete: [],
      list_id_file_delete_cover: [],
      list_file_cover_edit: [],
      key_type_id: 1,
      deleteId: null,
      listDataType: [],
      comFilename: 1,
      listPropertyType: [],
      listPropertyTypeAll: [],
      CarElectric: '',
      listUser: [],
      listUserAll: [],
      componentKey: 0,
      list_file: [],
      list_file_cover: [],
      maxFileSize: 2097152 * 50,
      listCarSell: [
        {
          id: 1,
          name: "For sell",
        },
        {
          id: 2,
          name: "Sold out",
        },
        {
          id: 3,
          name: "Cancel",
        },
      ],
      listShowRoom: [],
      listVehicleCategory: [],
    };
  },
  async mounted() {
     this.getLisVehicleCategory();
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.obj_data = this.$commonFuction.convertJsonObject(this.model);
      this.obj_data.vehicle_category_id = this.obj_data?.obj_vehicle_category?.id;
      if (!this.$commonFuction.isEmpty(this.model?.list_file_edit)) {
        var list_file_edit = this.model?.list_file_edit;
        for (let i = 0; i < list_file_edit.length; i++) {
          var item_file = list_file_edit[i];
          var obj = { id: item_file.id, name: '', file: '', objectURL: item_file.url, type: 'old_edit' }; // type:'old_edit' nếu gặp type này ko update avatar
          this.list_file_cover.push(obj);
        }
      }
      if (!this.$commonFuction.isEmpty(this.model?.list_file_edit_normal)) {
        var list_file_edit_normal = this.model?.list_file_edit_normal;
        for (let i = 0; i < list_file_edit_normal.length; i++) {
          var item_file_normal = list_file_edit_normal[i];
          var obj_list_normal = { id: item_file_normal.id, name: '', file: '', objectURL: item_file_normal.url, type: 'old_edit' }; // type:'old_edit' nếu gặp type này ko update avatar
          this.list_file.push(obj_list_normal);
        }
      }
      this.componentKey++;
    } else {
      this.obj_data = {
        active: true,
        new: true,
        type_of_price: '1',
        ordinal: 1,
        discount: '%',
        description: ''
      };
      this.componentKey++;
    }
  },
  methods: {
      handleCroppedImage(itemFile) {
       this.list_file_cover=[];
       this.list_file_cover.push(itemFile)
    },
    handleMaxCharacter(field, event, maxLength = 255) {
      let value = event
      if (value.length > maxLength) {
        value = value.slice(0, maxLength)
      }
      this.obj_data[field] = value; 
    },
    handleDataCkditor: function (e, index, key) {
      var dataContent = e;
      if (Array.isArray(dataContent)) {
        dataContent = dataContent.join(' ');  
      }
      if (key == 'description') {
        this.obj_data.description = dataContent;
      }
    },

    async onFileSelectFile(event) {
      const that = this;
      const files = event.target.files || event.dataTransfer.files;

      // Kiểm tra nếu tổng số ảnh đã chọn vượt quá 50
      if (this.list_file.length + files.length > 50) {
        alert("You can only upload a maximum of 50 images.");
        event.target.value = null;
        return;
      }

      if (files.length > 0) {
        const acceptTags = ['jpeg', 'jpg', 'gif', 'png', 'JPEG', 'JPG', 'PNG', 'GIF', 'svg', 'SVG'];

        for (let i = 0; i < files.length; i++) {
          const fileExtension = files[i].name.split('.').pop();

          // Kiểm tra định dạng ảnh
          if (!acceptTags.includes(fileExtension)) {
            alert("Only post formats are supported: jpeg, jpg, gif, png, svg");
            event.target.value = null;
            return;
          }

          that.obj_data.filename = files[i].name;
          this.comFilename++;
        }

        // Thêm ảnh mới vào danh sách
        const arrTemp = [];
        for (let file of files) {
          file.source = file;
          file.objectURL = window.URL.createObjectURL(file);
          arrTemp.push(file);
        }

        this.list_file = this.list_file.concat(arrTemp);
      }

      // Đặt lại giá trị input để có thể chọn lại cùng một file nếu cần
      event.target.value = null;
    },
    async onFileSelectFileCover(event) {
      let files = event.target.files || event.dataTransfer.files;
      if (files.length > 50) {
        alert("You can only upload a maximum of 50 files at a time");
      } else {
        // Kiểm tra định dạng ảnh
        let acceptTags = ['jpeg', 'jpg', 'gif', 'png', 'JPEG', 'JPG', 'PNG', 'GIF', 'svg', 'SVG'];
        for (let i = 0; i < files.length; i++) {
          const fileExtension = files[i].name.split('.').pop();
          if (!acceptTags.includes(fileExtension)) {
            alert("Only post formats are supported: jpeg, jpg, gif, png, svg");
            event.target.value = null;
            return;
          }
        }

        // Xóa ảnh cũ nếu có, sử dụng hàm onFileClearCover
        if (this.list_file_cover.length > 0) {
          this.onFileClearCover(this.list_file_cover[0], 0);
        }

        // Thêm ảnh mới
        let file = files[0];
        file.source = file;
        file.objectURL = window.URL.createObjectURL(file);
        this.list_file_cover.push(file);

        // this.showCropper = true;
        // this.imageSrc = URL.createObjectURL(file);
        // this.keyCropper++;

        // Xóa giá trị input để cho phép chọn lại cùng file nếu cần
        event.target.value = null;
      }
      
    },




    async getLisVehicleCategory() {
      try {
        var where_key = { deleted: { _eq: false } };
        var list = await this.$CoreService.getLisVehicleCategory(where_key);
        if (list && list.list) {
          this.ListvehicleCategory = list.list;
        } else {
          console.log('No data returned');
        }
      } catch (error) {
        console.error('Error loading vehicle categories:', error);
      }
    },
    backToList() {
      this.$emit('back');
    },
    async validateData() {
      this.validationErrors = {};
      const fieldsToValidate = [
        { id: "vehicle_category_id", value: this.obj_data.vehicle_category_id },
        { id: "validator_content_description", value: this.obj_data.description },
      ];
      let isFormInvalid = false;
      for (let i = 0; i < fieldsToValidate.length; i++) {
        let field = fieldsToValidate[i];
        let inputElement = document.getElementById(field.id);
        if (inputElement && (inputElement.tagName === "INPUT" || inputElement.tagName === "TEXTAREA" || inputElement.tagName === "SELECT")) {
          if (this.$commonFuction.isEmptyObject(field.value)) {
            inputElement.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
            isFormInvalid = true;
          }
          else if (field.minValue !== undefined && field.value <= field.minValue) {
            inputElement.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
            isFormInvalid = true;
          }
          else {
            inputElement.setCustomValidity("");
          }
        }
      }
      let list_file_cover = document.getElementById("list_file_cover");
      if (this.list_file_cover.length === 0) {
        list_file_cover.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
        list_file_cover.reportValidity();
        isFormInvalid = true;
      } else {
        list_file_cover.setCustomValidity("");
      }
      let list_file = document.getElementById("list_file");
      if (this.list_file.length === 0) {
        list_file.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
        list_file.reportValidity();
        isFormInvalid = true;
      } else {
        list_file.setCustomValidity("");
      }
      let inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity() || isFormInvalid) {
        inpObj.reportValidity();
        return true;
      }
      return false;
    },
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return
      }
      var params = this.obj_data;
      params.list_file_cover = this.list_file_cover;
      params.list_file_cover_edit = this.list_file_cover_edit;
      params.list_file = this.list_file;
      params.list_id_file_delete = this.list_id_file_delete;
      params.list_id_file_delete_cover = this.list_id_file_delete_cover;
      console.log('paramsparamsparams', params);
      this.$emit('save', params)
    },
    onFileClear(item, index) {
      var type = item?.type ?? null
      if (type == 'old_edit') {
        this.list_id_file_delete.push(item);
      }
      this.list_file.splice(index, 1);
    },
    onFileClearCover(item, index) {
      var type = item?.type ?? null
      if (type == 'old_edit') {
        this.list_id_file_delete_cover.push(item);
      }
      this.list_file_cover.splice(index, 1);
    },
  },
};
</script>
<style lang="scss">
.p-formgrid {
  padding-top: 20px;
}

.main-style-button {
  background-color: #FFDF01 !important;
}

.opacity-text-file {
  opacity: 0.5;
}

.calendar-css-margin1 {
  padding-right: 0px !important;
}

.calendar-css-margin2 {
  padding-left: 0px !important;
}

.p-multiselect {
  width: 450px;
}

.p-multiselect-label:not(.p-placeholder) {
  padding-top: .25rem;
  padding-bottom: .25rem;
}

.category-item-value {
  padding: .25rem .5rem;
  border-radius: 3px;
  display: inline-flex;
  margin-right: .2rem;
  background-color: var(--primary-color);
  color: var(--primary-color-text);
}

.p-multiselect-label-container {
  height: 40px;
}

.p-inputtext {
  margin: 0px 0px 0px 4px;
}

@media screen and (min-width: 1001px) {
  .input_distance {
    width: 728px !important;
  }
}

label.p-col-fixed txt-right {
  margin-bottom: 0px !important;
}

div.p-card-field {
  padding: 0px !important;
}

.p-col-fixed {
  padding: 0px !important;
  margin: 0px 0px 0px 9px !important;
}

.input_text {
  width: 760px !important;
  height: 48px !important;
}



.multiselect {
  width: 760px !important;
}



.vs__clear {
  display: none;
}

.input_width {
  width: 760px !important;
  height: 48px !important;
}

#distance {
  width: 1px !important;
  height: 48px !important;
  border-left: 0px;
  border-top: 0px;
  border: 1px solid #C8C8C8;
  border-radius: 0px;
}

.manager-title {
  font-size: 24px !important;
}

.input-dif {
  margin-left: 5px !important;
  border-top: 0px;
}

.p-inputgroup-addon {
  height: 48px;
}


.p-col-fixed {
  padding: 0px !important;
}

label.p-col-fixed txt-right {
  margin-bottom: 0px !important;
}

div.p-card-field {
  padding: 0px !important;
}

.margin {
  margin-bottom: 12px !important;
}

.border_color {
  border: 1px solid #C8C8C8;
}

.text {
  font-weight: normal !important;
  margin-left: 15px !important;
}

.div_check {
  margin-top: 12px !important;
}

//responsive
@media screen and (max-width: 600px) {
  .input_width {
    width: 100% !important;
  }

  .div-button {
    padding: 8px !important;
  }

  #distance {
    text-align: left !important;
    padding: 6.8px;
    width: 100% !important;
  }

  .p-inputgroup-addon {
    margin-right: 12px;
  }
}

@media screen and (max-width: 1000px) {
  .input_width {
    width: 100% !important;
  }

  .div-button {
    padding: 8px !important;
  }

  .p-inputgroup-addon {
    margin-right: 12px;
  }

  #distance {
    text-align: left !important;
    padding: 6.8px;
  }
}

.p-button-outlined {
  .p-button-label {
    color: #000000 !important;
  }
}

.cus-text {
  margin-left: 2px;
  margin-top: 4px;
}

.style-box-phone {
  border: 1px solid #a6a6a6;
  width: 100%;
  display: flex;

  .p-dropdown {
    width: 100px;
    border: 0px;
    box-shadow: none !important;
  }

  .p-focus {
    border: 0px;
    box-shadow: none;
  }

  .p-dropdown:focus {
    border: 0px;
    box-shadow: none;
  }

  input {
    width: calc(100% - 100px);
    margin-left: 0px;
    border: 0px;
  }

  .p-inputtext:enabled:focus {
    border: 0px;
    box-shadow: none;
  }
}

.style_list_image {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;

  .box-image {
    width: 100px;
    height: 100px;
    margin-top: 8px;
    margin-bottom: 8px;
    position: relative;

    .style_img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border: 1px solid #D0D4D9;
      border-radius: 10px;
    }

    .button-clear {
      width: 20px;
      height: 20px;
      position: absolute;
      top: 1px;
      right: 8px;
    }
  }
}

.style_box_room {
  display: flex;
}

.style_box_lat_log {
  display: flex;

  .box_lat_log {
    width: 50%;
  }
}

.style_title_group {
  font: normal normal bold 20px/27px Segoe UI;
  letter-spacing: 0px;
  color: #666666;
  text-transform: uppercase;
}

.style_box_price {
  padding-left: 35px !important;
}

.style_rad_button {
  label {
    margin-bottom: 0px;
    margin-left: 15px;
  }
}

.style_btn_add_type {
  width: 60px;
}

.style_title_group_car_infomation {
  padding: 10px 0 0 0 !important;
  font: normal normal bold 20px/27px Segoe UI;
  letter-spacing: 0px;
  color: #0c0101;
  text-transform: uppercase;
}

.indam-car-for-sell {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
}
</style>
